module.exports = __webpack_public_path__ + "img/p23.caa438e6.png";